import React from "react";

export type ListTableScrollVariant = "data-table" | "cases";

export interface ListTableScrollRegionProps extends React.HTMLAttributes<HTMLDivElement> {
  scrollVariant?: ListTableScrollVariant;
}

const SCROLL_VARIANT_CLASS: Record<ListTableScrollVariant, string> = {
  "data-table": "data-table__scroll",
  cases: "cases-table-scroll",
};

export const ListTableScrollRegion = React.forwardRef<HTMLDivElement, ListTableScrollRegionProps>(
  ({ className, style, scrollVariant = "data-table", children, ...rest }, ref) => {
    const scrollClass = SCROLL_VARIANT_CLASS[scrollVariant];
    const mergedClass = [scrollClass, className].filter(Boolean).join(" ");
    const baseStyle: React.CSSProperties =
      scrollVariant === "cases"
        ? { width: "100%", ...style }
        : { maxWidth: "100%", minWidth: 0, width: "100%", ...style };

    return (
      <div ref={ref} className={mergedClass} style={baseStyle} {...rest}>
        {children}
      </div>
    );
  }
);

ListTableScrollRegion.displayName = "ListTableScrollRegion";
